var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatWithNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H20V18H5.17L4 19.17V6ZM4 4C2.9 4 2.01 4.9 2.01 6L2 24L6 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4H4ZM6 14H14V16H6V14ZM6 11H18V13H6V11ZM6 8H18V10H6V8Z",
    fill: "#DEDFEC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 4,
    r: 3.5,
    fill: "#FF6F75",
    stroke: "#252643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithNotification);
export default __webpack_public_path__ + "static/media/chat_with_notification.17420ce65d3b7671919e7e3e2f0fadc1.svg";
export { ForwardRef as ReactComponent };